<div *ngIf="isLoading" class="skeleton-order-details">
  <div class="skeleton-header skeleton"></div>
  <div class="skeleton-grid">
    <div class="skeleton-left">
      <div class="skeleton-card">
        <div class="skeleton skeleton-line med"></div>
        <div class="skeleton skeleton-line short"></div>
        <div style="display: flex; gap: 10px; margin-top: 20px">
          <div class="skeleton" style="height: 60px; flex: 1"></div>
          <div class="skeleton" style="height: 60px; flex: 1"></div>
          <div class="skeleton" style="height: 60px; flex: 1"></div>
        </div>
        <div class="skeleton skeleton-line" style="margin-top: 30px; height: 100px"></div>
      </div>
      <div class="skeleton-card"></div>
    </div>
    <div class="skeleton-right">
      <div class="skeleton-card" style="height: 400px"></div>
      <div class="skeleton-card" style="height: 150px"></div>
    </div>
  </div>
</div>

<div *ngIf="!isLoading && bookingData" class="detail-container">
  <!-- Header -->
  <div class="detail-header">
    <div class="header-left">
      <button class="back-btn" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1>
        Booking Details:
        {{ bookingData.bookingId || bookingId }}
      </h1>

      <!-- Inline LPO Approved Msg -->
      <span class="lpo-approved-inline" *ngIf="bookingData.lpoApproved">
        <i class="fa-solid fa-circle-check"></i>
        LPO Approved
      </span>

      <!-- Timesheet Completed Msg -->
      <span class="status-info-tag yellow-tag" *ngIf="bookingData.timesheet?.isCompleted">
        <i class="fa-solid fa-calendar-check"></i>
        Timesheet Completed
      </span>

      <!-- Invoice Completed Msg -->
      <span class="status-info-tag yellow-tag" *ngIf="bookingData.invoiceFinalized">
        <i class="fa-solid fa-file-invoice-dollar"></i>
        Invoice Completed
      </span>
    </div>

    <div class="header-right">
      <!-- Rate Experience Action Button -->
      <div class="header-actions" *ngIf="
          ['Completed', 'Rejected'].includes(capitalize(bookingData.status))
        ">
        <button class="rate-btn-header" (click)="openReviewDialog()">
          <i class="fa-solid fa-star"></i>
          <span>{{ reviewExists ? "Edit Review" : "Rate Experience" }}</span>
        </button>
      </div>



      <!-- WAITING FOR LPO (Only show if Quotation NOT approved) -->
      <div class="header-actions" *ngIf="
          (bookingData.status === 'Accepted' ||
            bookingData.status === 'Confirmed') &&
          (bookingData.lpoGenerated || bookingData.LPO) &&
          !bookingData.lpoApproved &&
          !bookingData.quotationApproved
        ">
        <div class="status-info-badge wait-lpo-badge">
          <i class="fa-solid fa-spinner fa-spin"></i> Waiting for Vendor LPO
          Confirmation
        </div>
      </div>

      <div class="status-badge-header" [ngClass]="bookingData.status?.toLowerCase()">
        {{
        bookingData.status === "Rejected" ? "Unavailable" : (bookingData.status === "Accepted" ? "Vendor Accepted Enquiry" : bookingData.status)
        }}
      </div>

      <!-- Reject & Cancel Booking for Customer (During Price Negotiation) -->
      <button class="status-action-btn cancel-btn-header" *ngIf="bookingData?.awaitingCustomerPriceConsent"
        (click)="cancelBookingDueToPrice()">
        <i class="fa-solid fa-ban"></i>
        <span>Reject & Cancel</span>
      </button>

      <!-- Upload LPO Button in Header -->
      <button class="status-action-btn upload-lpo-btn-header" *ngIf="
          (bookingData.status === 'Accepted' || bookingData.status === 'Confirmed') &&
          !bookingData.lpoGenerated &&
          !bookingData.LPO &&
          (!bookingData.quotationGenerated || bookingData.quotationApproved)
        " (click)="openLpoViewer(true)">
        <i class="fa-solid fa-file-arrow-up"></i>
        <span>Upload LPO</span>
      </button>

      <button class="status-action-btn cancel-btn-header" *ngIf="
          ['Pending', 'Accepted', 'Confirmed'].includes(bookingData.status) &&
          !bookingData.lpoGenerated &&
          !bookingData.LPO
        " (click)="cancelBooking()">
        <i class="fa-solid fa-ban"></i>
        <span>Cancel Booking</span>
      </button>
    </div>
  </div>

  <div class="detail-grid">
    <!-- Left Column -->
    <div class="left-col">
      <!-- 1. Booking Summary Wrapper Card -->
      <div class="card booking-summary-card">
        <!-- Price Adjustment Alert Banner (With Actions) -->
        <div *ngIf="bookingData?.awaitingCustomerPriceConsent" class="price-adjustment-banner action-needed">
          <div class="banner-content">
            <mat-icon>priority_high</mat-icon>
            <div class="text-group">
              <span class="banner-title">Price Adjustments Proposed</span>
              <span class="banner-desc">
                The vendor has proposed transport costs on your LPO.
              </span>
            </div>
          </div>
          <div class="banner-actions">
            <div class="adjusted-total">
              <span class="label">New Total:</span>
              <span class="value">{{ getFinalTotal() | number: "1.2-2" }} AED</span>
            </div>
            <div class="buttons">
              <button class="btn btn-view" (click)="openLpoViewer()">
                <mat-icon>visibility</mat-icon> View Details
              </button>
              <button class="btn btn-accept" (click)="acceptPriceAdjustment()">
                <mat-icon>check</mat-icon> Accept
              </button>
              <button class="btn btn-reject" (click)="rejectPriceAdjustment()">
                <mat-icon>close</mat-icon> Reject
              </button>
            </div>
          </div>
        </div>

        <!-- Price Adjustment Info Banner (Static view for after consent or when viewed by vendor if applicable) -->
        <div *ngIf="
            (bookingData?.deliveryCharge > 0 || bookingData?.discount > 0) &&
            !bookingData?.awaitingCustomerPriceConsent
          " class="price-adjustment-banner">
          <div class="banner-content">
            <mat-icon>info</mat-icon>
            <div class="text-group">
              <span class="banner-title">Pricing Adjusted by Vendor</span>
              <span class="banner-desc">
                Transport costs have been applied to this booking.
              </span>
            </div>
          </div>
          <div class="adjusted-total">
            <span class="label">Total Adjusted:</span>
            <span class="value">{{ getFinalTotal() | number: "1.2-2" }} AED</span>
          </div>
        </div>

        <div class="summary-header-row">
          <div class="id-group">
            <h2>{{ bookingData.bookingId || bookingId }}</h2>
            <div class="badges-row">
              <span class="status-badge-modern" [ngClass]="bookingData.status?.toLowerCase()">
                {{
                bookingData.status === "Rejected"
                ? "Unavailable"
                : (bookingData.status === "Accepted" ? "Vendor Accepted Enquiry" : bookingData.status)
                }}
              </span>
              <span class="created-date">
                {{ getTimeAgo(bookingData.createdAt) }}
              </span>
            </div>

            <!-- Accepted/LPO Alerts for Customer (Inside Card like Vendor section) -->
            <div class="alert-box warning-modern" *ngIf="
                bookingData.status === 'Accepted' &&
                !bookingData.vendorConfirmed
              " style="margin-top: 20px">
              <i class="fa-solid fa-circle-info"></i>
              <div class="reason-content">
                <p>
                  Booking is accepted. Waiting for the vendor to confirm and
                  proceed.
                </p>
              </div>
            </div>

            <div class="alert-box primary-modern" *ngIf="
                bookingData.quotationGenerated && !bookingData.quotationApproved
              " style="margin-top: 20px">
              <i class="fa-solid fa-file-invoice"></i>
              <div class="reason-content">
                <p>
                  Vendor has sent a <strong>Quotation</strong>. Please review
                  and approve it to proceed.
                </p>
              </div>
            </div>

            <div class="alert-box success-modern" *ngIf="
                (bookingData.status === 'Accepted' ||
                  bookingData.status === 'Confirmed') &&
                bookingData.vendorConfirmed &&
                !bookingData.lpoGenerated &&
                !bookingData.quotationApproved &&
                !bookingData.quotationGenerated
              " style="margin-top: 20px">
              <i class="fa-solid fa-circle-check"></i>
              <div class="reason-content">
                <p>
                  Vendor has confirmed this booking. Waiting for you to upload
                  the <strong>LPO</strong> to finalize the booking.
                </p>
              </div>
            </div>

            <!-- LPO Rejection Alert for Customer -->
            <div class="alert-box error-modern" *ngIf="bookingData.lpoRejected && !bookingData.lpoApproved"
              style="margin-top: 20px">
              <i class="fa-solid fa-circle-xmark"></i>
              <div class="reason-content">
                <p>
                  Your <strong>LPO</strong> has been rejected by the vendor.
                  Please review and resubmit with modifications.
                </p>
                <p *ngIf="bookingData.lpoRejectionReason" style="margin-top: 8px">
                  <strong>Reason:</strong> {{ bookingData.lpoRejectionReason }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Rejection Reason for Customer View (Matches Vendor Style) -->
        <div class="rejection-reason-strip" *ngIf="
            ['rejected', 'cancelled'].includes(
              bookingData.status?.toLowerCase()
            ) && bookingData.reason
          ">
          <i class="fa-solid fa-circle-xmark"></i>
          <div>
            <strong>{{
              bookingData.status === "Rejected"
              ? "Unavailable Reason:"
              : "Cancellation Reason:"
              }}</strong>
            <span>{{ bookingData.reason }}</span>
          </div>
        </div>

        <div class="info-grid-row">
          <div class="info-item">
            <label>{{
              bookingData.customer?.priceType === "per_trip"
              ? "DATE"
              : "START DATE"
              }}</label>
            <p class="val-bold">
              {{
              bookingData.customer?.startDate?.toDate() | date: "dd/MM/yyyy"
              }}
            </p>
            <span class="sub-hint">{{
              getDaysUntil(bookingData.customer?.startDate)
              }}</span>
          </div>
          <ng-container *ngIf="bookingData.customer?.priceType !== 'per_trip'">
            <div class="info-item">
              <label>END DATE</label>
              <p class="val-bold">
                {{
                bookingData.customer?.endDate?.toDate() | date: "dd/MM/yyyy"
                }}
              </p>
            </div>
            <div class="info-item">
              <label>DURATION</label>
              <p class="val-bold">{{ duration }}</p>
            </div>
          </ng-container>
          <div class="info-item" *ngIf="bookingData.customer?.priceType === 'per_trip'">
            <label>NO. OF TRIPS</label>
            <p class="val-bold">{{ numberOfTrips }}</p>
          </div>
        </div>

        <div class="info-grid-row">
          <div class="info-item">
            <label>EMIRATE</label>
            <p class="val-bold">{{ bookingData.equipment?.emirate || "—" }}</p>
          </div>
          <div class="info-item">
            <label>DELIVERY LOCATION</label>
            <p class="val-bold">{{ bookingData.customer?.location || "—" }}</p>
          </div>
        </div>

        <div class="info-grid-row last-row">
          <div class="info-item">
            <label>RENTAL AMOUNT (AED)</label>
            <p class="val-bold">AED {{ totalAmount | number }}</p>
          </div>
          <div class="info-item" *ngIf="bookingData.deliveryCharge">
            <label>TRANSPORT COST</label>
            <p class="val-bold" style="color: #1d4ed8">
              +AED {{ bookingData.deliveryCharge | number }}
            </p>
          </div>

          <div class="info-item">
            <label>TOTAL AMOUNT (AED)</label>
            <p class="val-highlight">AED {{ getFinalTotal() | number }}</p>
          </div>
          <div class="info-item">
            <label>INCLUDES</label>
            <div class="includes-text">
              <span class="incl-box">Driver:
                <strong>{{ isIncluded("Driver") ? "Yes" : "No" }}</strong></span>
              <span class="incl-box">Fuel:
                <strong>{{ isIncluded("Fuel") ? "Yes" : "No" }}</strong></span>
              <span class="incl-box">Salik:
                <strong>{{ isIncluded("Salik") ? "Yes" : "No" }}</strong></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Vendor Details (Instead of Customer Details) -->
      <div class="card vendor-card">
        <div class="card-header-clean">
          <h3>Vendor Details</h3>

          <div class="rating-display-header">
            <div class="stars">
              <i *ngFor="let s of [1, 2, 3, 4, 5]" class="fa-star"
                [ngClass]="s <= vendorAvgRating ? 'fa-solid' : 'fa-regular'"></i>
            </div>
            <span class="num">{{ vendorAvgRating | number: "1.1-1" }}</span>
            <span class="count">({{ vendorReviewCount }})</span>
          </div>
        </div>

        <div class="vendor-grid-modern" *ngIf="
            bookingData.status !== 'Pending' &&
              bookingData.status !== 'Rejected';
            else lockedVendor
          ">
          <div class="company-highlight">
            <div class="co-icon-box">
              <i class="fa-solid fa-store"></i>
            </div>
            <div class="co-details">
              <h4>{{ vendorDetails?.companyName }}</h4>
              <p class="address">
                <i class="fa-solid fa-location-dot"></i>
                {{ vendorDetails?.address }}
              </p>
            </div>
          </div>

          <div class="divider-line"></div>

          <div class="details-grid">
            <div class="d-item">
              <label><i class="fa-solid fa-user"></i> Vendor Name</label>
              <p>{{ vendorDetails?.name }}</p>
            </div>
            <div class="d-item">
              <label><i class="fa-solid fa-phone"></i> Contact</label>
              <p>{{ vendorDetails?.phone || "—" }}</p>
            </div>
            <div class="d-item">
              <label><i class="fa-solid fa-envelope"></i> Email</label>
              <p>{{ vendorDetails?.email || "—" }}</p>
            </div>
            <div class="d-item" *ngIf="vendorDetails?.trn">
              <label><i class="fa-solid fa-id-card"></i> TRN/License</label>
              <p>{{ vendorDetails?.trn }}</p>
            </div>
          </div>
        </div>

        <!-- Locked State -->
        <ng-template #lockedVendor>
          <div class="locked-state">
            <i class="fa-solid fa-lock"></i>
            <p>
              The details will be shown after the vendor accepts the booking.
            </p>
          </div>
        </ng-template>
      </div>

      <!-- 3. Documents -->
      <div class="card plain-card" *ngIf="bookingData">
        <h3>Booking Documents</h3>
        <div class="doc-buttons-row" *ngIf="
            ['Accepted', 'Confirmed', 'Started', 'Completed'].includes(
              capitalize(bookingData.status)
            );
            else lockedDocs
          ">
          <!-- View LPO -->
          <button class="doc-btn-large" [class.attention-pulse]="highlightLpo" (click)="openLpoViewer(!(bookingData.lpoGenerated || bookingData.LPO))" [disabled]="
              bookingData.status === 'Rejected' ||
              bookingData.status === 'Cancelled'
            ">
            <i class="fa-solid fa-file-contract"></i>
            <span>{{
              bookingData.lpoGenerated || bookingData.LPO
              ? "View LPO"
              : "Upload LPO"
              }}</span>
          </button>

          <!-- Quotation (only show if generated by vendor) -->
          <button class="doc-btn-large" *ngIf="bookingData.quotationGenerated" [class.attention-pulse]="
              !bookingData.quotationApproved
            " (click)="viewQuotation()">
            <i class="fa-solid fa-file-invoice"></i>
            <span>{{
              bookingData.quotationApproved
              ? "View Quotation"
              : "Approve Quotation"
              }}</span>
          </button>

          <!-- View Timesheet: Vendor always sees it (to create); Customer only sees it after vendor initiates -->
          <ng-container *ngIf="bookingData.quotationApproved || bookingData.lpoApproved">
            <!-- If vendor has already started the timesheet → show button to everyone -->
            <button class="doc-btn-large" [class.attention-pulse]="highlightTimesheet" (click)="openTimesheetViewer()"
              *ngIf="bookingData.timesheet?.rowsInitiatedBy">
              <i class="fa-regular fa-calendar-check"></i>
              <span>Timesheet</span>
            </button>
            <!-- If vendor hasn't started yet → show a waiting note (customer side) -->
            <div class="doc-btn-large doc-btn-disabled" *ngIf="!bookingData.timesheet?.rowsInitiatedBy"
              style="opacity: 0.55; cursor: not-allowed; pointer-events: none; display:flex; flex-direction:column; align-items:center; gap:4px;">
              <i class="fa-regular fa-calendar-check"></i>
              <span>Timesheet</span>
              <small style="font-size:10px; color:#64748b;">Awaiting vendor</small>
            </div>
          </ng-container>

          <!-- View Invoice (Only shown after Vendor finalizes or uploads it) -->
          <button class="doc-btn-large" [class.attention-pulse]="highlightInvoice" (click)="openInvoiceViewer()" *ngIf="
              bookingData.invoiceFinalized ||
              bookingData.invoiceUrl ||
              bookingData.invoice?.url
            ">
            <i class="fa-solid fa-file-invoice"></i>
            <span>View Invoice</span>
          </button>
        </div>

        <ng-template #lockedDocs>
          <div class="locked-state">
            <i class="fa-solid fa-lock"></i>
            <p>
              LPO and Invoice will be available once the booking is confirmed by
              the vendor.
            </p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Right Column -->
    <div class="right-col">
      <div class="card equip-card">
        <h3>Equipment Details</h3>
        <div class="equip-image-placeholder">
          <img *ngIf="bookingData.equipment?.images?.length" [src]="bookingData.equipment.images[0]" alt="Equipment" />
        </div>
        <div class="equip-data-list">
          <div class="e-item">
            <label>EQUIPMENT ID</label>
            <p>{{ bookingData.equipment?.code || "—" }}</p>
          </div>
          <div class="e-item">
            <label>EQUIPMENT NAME</label>
            <p>{{ bookingData.equipment?.name }}</p>
          </div>
          <div class="e-item">
            <label>BRAND / MODEL</label>
            <p>
              {{ bookingData.equipment?.brand }}
              {{ bookingData.equipment?.model }}
            </p>
          </div>
          <div class="e-item">
            <label>PLATE NO.</label>
            <p>{{ bookingData.equipment?.plate_number || "—" }}</p>
          </div>
        </div>
      </div>

      <div class="card info-blue-card">
        <h3><i class="fa-solid fa-circle-info"></i> Need Help?</h3>
        <ul>
          <li>
            If you have any issues with this booking, please contact the vendor
            directly.
          </li>
          <li>For technical support, please contact Aluguloo customer care.</li>
          <li>
            You can download your LPO and Invoice once they are generated by the
            vendor.
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Cancel Reason Dialog Template (Matching Vendor Rejection Style) -->
  <ng-template #cancelReasonDialog>
    <h2 mat-dialog-title>Cancel Booking</h2>
    <mat-dialog-content>
      <p>
        Please select a reason for cancelling this booking. The vendor will be
        notified.
      </p>

      <mat-radio-group [(ngModel)]="selectedCancelReason" style="
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 15px;
          margin-bottom: 20px;
        ">
        <mat-radio-button *ngFor="let reason of cancelReasonList" [value]="reason" color="primary">
          {{ reason }}
        </mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Additional Message (Optional)</mat-label>
        <textarea matInput [(ngModel)]="cancelMessage" rows="3"
          placeholder="Provide any additional details..."></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end" style="padding-bottom: 20px; padding-right: 20px; gap: 12px">
      <button [mat-dialog-close]="false" style="
          background: white;
          border: 1px solid #ddd;
          border-radius: 6px;
          padding: 8px 16px;
          font-weight: 600;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s;
        ">
        Go Back
      </button>
      <button [mat-dialog-close]="true" [disabled]="!selectedCancelReason" [ngStyle]="
          !selectedCancelReason ? { opacity: '0.5', cursor: 'not-allowed' } : {}
        " style="
          background-color: #ef4444;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 8px 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s;
        ">
        Confirm Cancellation
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>